import React from "react";
import Col from "./Flex/Col";
import Row from "./Flex/Row";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/pro-light-svg-icons/faClose";
import { useClasses, Button } from "..";
const styles = (theme) => ({
    sidebar: {
        backgroundColor: theme.palette.get("tertiary"),
        height: "100vh",
        boxShadow: "rgba(0, 0, 0, 0.4) 0px 0px 4px 0px",
        overflowY: "scroll",
        "-ms-overflow-style": "none,",
        scrollbars: "none",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
            display: "none",
        },
    },
    head: {
        color: theme.palette.get("grey"),
        backgroundColor: "#252f3e",
        minHeight: "50px",
    },
    body: {
        padding: "0px 16px 0px",
        height: "calc(100vh - 50px)",
        overflowY: "scroll",
        "-ms-overflow-style": "none,",
        scrollbars: "none",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
            display: "none",
        },
    },
});
export default function Sidebar(props) {
    const classes = useClasses(styles);
    return (React.createElement("nav", { className: classes.sidebar },
        React.createElement("div", { className: classes.placeholder }),
        React.createElement("div", { className: classes.head },
            React.createElement(Row, { spacing: 8, vertical: true },
                React.createElement(Col, { xs: "rest-fixed" }, props.logo),
                React.createElement(Button, { xs: "40px", md: "hidden-up", tertiary: true, onClick: () => {
                        if (props.onClose)
                            props.onClose();
                    } },
                    React.createElement(FontAwesomeIcon, { icon: faClose })))),
        React.createElement("div", { className: classes.body }, props.children)));
}
